import { DownOutlined } from "@ant-design/icons";
import React, { ReactNode, useLayoutEffect, useRef, useState } from "react";
import "./ExpandableContent.css";

interface ExpandableContentProps {
  children: ReactNode;
  maxHeight: number;
}

export function ExpandableContent({ children, maxHeight }: ExpandableContentProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (contentRef.current) {
      if (contentRef.current.scrollHeight > maxHeight) {
        setIsOverflowing(true);
      } else {
        setIsOverflowing(false);
      }
    }
  }, [children, maxHeight]);

  const toggleExpanded = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsExpanded(!isExpanded);
  };

  const isClipped = isOverflowing && !isExpanded;

  return (
    <div
      ref={contentRef}
      className={`ExpandableContent ${
        isClipped ? "is-clipped" : ""
      } ${isExpanded ? "is-expanded" : ""}`}
      style={isClipped ? { maxHeight: `${maxHeight}px` } : {}}
    >
      {children}
      {isOverflowing && (
        <div className="ExpandableContent-fade" onClick={toggleExpanded}>
          <span className="ExpandableContent-text">
            <DownOutlined />
          </span>
        </div>
      )}
    </div>
  );
}
